import { Injectable } from '@angular/core';
import { handleError } from '@core/helpers';
import { ReviewService } from '@core/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  clearSelectedGrant,
  clearSelectedGrantSuccess,
  getSelectedGrant,
  getSelectedGrantFailure,
  getSelectedGrantSuccess,
  setSelectedGrant,
  setSelectedGrantFailure,
  setSelectedGrantSuccess,
} from './actions';

@Injectable()
export class PortalReviewEffects {
  clearSelectedGrant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(clearSelectedGrant),
      map(() => {
        localStorage.removeItem('currentGrant');
        return clearSelectedGrantSuccess();
      }),
    ),
  );

  getSelectedGrant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSelectedGrant),
      switchMap(() =>
        this.reviewService.getSelectedGrant().pipe(
          map((currentGrant) => getSelectedGrantSuccess({ currentGrant })),
          catchError((error) => handleError(error, getSelectedGrantFailure)),
        ),
      ),
    ),
  );

  setSelectedGrant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSelectedGrant),
      switchMap(({ grant }) =>
        this.reviewService.setSelectedGrant(grant).pipe(
          map((currentGrant) => setSelectedGrantSuccess({ currentGrant })),
          catchError((error) => handleError(error, setSelectedGrantFailure)),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private reviewService: ReviewService,
  ) {}
}
